// frontend/src/components/Common/Comments/commentLabels.js
//
// Builds the reference text stored in core.comments.sub_entity_label for a task.
// e.g. "CORTE · Cortar tecido · L3 · 69140 / Azul"

export const SUB_ENTITY = {
  LINE_OPERATION: 'line_operation',
};

export const buildTaskCommentLabel = ({
  areaCode,
  operationLabel,
  matrixLineNo,
  productCode,
  productColor,
} = {}) => {
  const product = [productCode, productColor].filter(Boolean).join(' / ');
  return [
    areaCode,
    operationLabel,
    matrixLineNo != null ? `L${matrixLineNo}` : null,
    product || null,
  ]
    .filter(Boolean)
    .join(' · ')
    .slice(0, 255);
};